var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCouponCode(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "#ffffff",
    className: "bi bi-hourglass-split",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-.5v-1a4.5 4.5 0 0 0-2.5-4V8a4.5 4.5 0 0 0 2.5-4V3h.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h.5v1a4.5 4.5 0 0 0 2.5 4v1a4.5 4.5 0 0 0-2.5 4v1h-.5a.5.5 0 0 0-.5.5v1zM3 3V2h10v1a3.5 3.5 0 0 1-1.75 3.03L8 8.5 4.75 6.03A3.5 3.5 0 0 1 3 3zm1.75 7.97L8 7.5l3.25 3.47A3.5 3.5 0 0 1 13 12v1H3v-1a3.5 3.5 0 0 1 1.75-3.03z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCouponCode);
export default __webpack_public_path__ + "static/media/ic_coupon_code.94f35361274ce19fd6c86faf1d6ebb2d.svg";
export { ForwardRef as ReactComponent };